module.exports = __webpack_public_path__ + "img/section3Logo1.24912105.png";